import { Add, AddShoppingCart, Calculate } from '@mui/icons-material';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React, { useContext, useMemo, useState } from 'react'
import { AppContext } from '../../../../Layout/Layout';
import { API } from 'aws-amplify';
import { createUserProductsCart, userProductsCartsByCarttableID } from '../../../../Layout/MutaionsAndQueries';
import { showToast } from '../../../../components/ToastUtils';
import { CartProductQtyUpdateAPIfn } from '../../CartCommonFn';
import UOMConversion from '../../../../components/UOMConversion';
import { useTranslation } from 'react-i18next';
import { AddNewProductToCart, AlreadyProductInCart, CartStatusChecking, CreateNewCart, UpdateCartProductQty } from '../CartCUDFunctions';

function InputAndAddtoCartUI({ selectedProduct, count, setCount, setDialogVisible }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const { userDetails, accountDetails, CartProductRelatedStates, CartRelatedDispatch, Actions } = useContext(AppContext);

  const MaximumQty = useMemo(() => {
    if (selectedProduct.ChangeUOMDetails) {
      return parseInt((selectedProduct.ProductCardState.QtyDetails.CurrentStock) / selectedProduct.ChangeUOMDetails.UOMQty)
    }
    else if (!selectedProduct.ChangeUOMDetails) {
      return parseInt(selectedProduct.ProductCardState.QtyDetails.CurrentStock)
    }
  }
    , [selectedProduct])

  const handleInputChange = (event) => {
    const enteredValue = event.target.value.trim();

    if (
      event.target.value === "" ||
      event.key === "Backspace" ||
      event.key === "Delete"
    ) {
      setCount("");
    } else {
      const numericValue = enteredValue.replace(/[^0-9]/g, "");
      const value = Number(numericValue);
      const newValue = Math.min(Math.max(value, 1), (MaximumQty));
      setCount(newValue);
    }
  };

  const handleInputBlur = () => {
    // If input is left empty, set it to 1 on blur
    if (count === "") {
      setCount(1);
    }
  };

  const handleAddToCart = async () => {
    setLoading(true);
    const UserDefaultAddress = accountDetails?.CustomerAddressInformation?.find(
      (defaultAddress) => defaultAddress.DefaultAddress !== ""
    ) || null;

    try {
      if (UserDefaultAddress) {
        const CartProductDetails = {
          ProductQuantity: count,
          ProductQuantityText: selectedProduct.Product.ProductUOMText,
          ProductPriceUOMCode: selectedProduct.ChangeUOMDetails ? selectedProduct.ChangeUOMDetails.UOM : selectedProduct.ProductCardState.PriceDetails.ProductPriceQuantityCode,
          CalculatedUOMQuantity: selectedProduct.ChangeUOMDetails ? count * parseFloat(parseFloat(selectedProduct.ChangeUOMDetails.UOMQty).toFixed(2)) : count,
          owner: userDetails.sub,
          ProductPrice: parseFloat(selectedProduct.ProductCardState.PriceDetails.ProductPrice),
          ProductDiscount: selectedProduct.ProductCardState.PriceDetails.DiscountPercentage || 0,
          userProductsCartProductdetailsId: selectedProduct.Product.id,
        }
        CartRelatedDispatch({ type: Actions.CartProductIDAdd, payload: selectedProduct.Product.id });


        if (CartProductRelatedStates.CartDetails.Status === "NoCart" || CartProductRelatedStates.CartDetails.Status === "Ordered") {

          const AddNewCartDetails = {
            CartId: userDetails.sub,
            CartStatus: "Open",
            UserAddress: UserDefaultAddress.FormattedAddress,
            CreatedBy: userDetails["custom:contactperson_UUID"]
          };
          const NewCartResponse = await CreateNewCart({ AddNewCartDetails });

          if (NewCartResponse.Status === "Open") {

            CartRelatedDispatch({ type: Actions.CartDetailsLoaded, payload: NewCartResponse });
            const AddProductResponse = await AddNewProductToCart({ CartProductDetails, carttableID: NewCartResponse.Data.id, userDetails });

            if (AddProductResponse.Status === "Success") {
              CartRelatedDispatch({ type: Actions.CartProductAdd, payload: { ...AddProductResponse.Data, Productdetails: selectedProduct.Product } });
              selectedProduct.setProductCardState({ type: "ReduceQty", payload: CartProductDetails.CalculatedUOMQuantity })
            }

            else if (AddProductResponse.Status === "Error") {
              CartRelatedDispatch({ type: Actions.CartProductIDRemove, payload: selectedProduct.Product.id });
              showToast("Something Went Wrong.Please Contact Admin", "error", 3000);
            }
          }
          else if (NewCartResponse.Status === "Error") {
            CartRelatedDispatch({ type: Actions.CartProductIDRemove, payload: selectedProduct.Product.id });
            showToast("Something Went Wrong.Please Contact Admin", "error", 3000);
          }
        }

        else if (CartProductRelatedStates.CartDetails.Status === "Open") {

          const SameProductResponse = await AlreadyProductInCart(
            {
              ProductID: CartProductDetails.userProductsCartProductdetailsId,
              ProductPriceUOMCode: CartProductDetails.ProductPriceUOMCode,
              carttableID: CartProductRelatedStates.CartDetails.Data.id
            })

          if (SameProductResponse.Status === "NotSameProductInCart") {

            const AddProductResponse = await AddNewProductToCart({ CartProductDetails, carttableID: CartProductRelatedStates.CartDetails.Data.id, userDetails });
            if (AddProductResponse.Status === "Success") {
              CartRelatedDispatch({ type: Actions.CartProductAdd, payload: { ...AddProductResponse.Data, Productdetails: selectedProduct.Product } });
              selectedProduct.setProductCardState({ type: "ReduceQty", payload: CartProductDetails.CalculatedUOMQuantity })
            }
            else if (AddProductResponse.Status === "Error") {
              CartRelatedDispatch({ type: Actions.CartProductIDRemove, payload: selectedProduct.Product.id });
              showToast("Something Went Wrong.Please Contact Admin", "error", 3000);
            }

          }
          else if (SameProductResponse.Status === "SameProductInCart") {

            let upDateQuantity = count + SameProductResponse.Data.ProductQuantity;
            let UpdateCalculatedUOMQuantity = CartProductDetails.CalculatedUOMQuantity + SameProductResponse.Data.CalculatedUOMQuantity;

            if (upDateQuantity > 9999) {
              showToast(`${t('You have reached the maximum quantity limit for this product.')} `, 3000)
            }
            else {
              const InputVariable = { id: SameProductResponse.Data.id, ProductQuantity: upDateQuantity, CalculatedUOMQuantity: UpdateCalculatedUOMQuantity }
              const UpdateCartProductQtyResponse = await UpdateCartProductQty(InputVariable)
              if (UpdateCartProductQtyResponse.Status === "Success") {
                CartRelatedDispatch({ type: Actions.CartProductQtyUpdate, payload: UpdateCartProductQtyResponse.Data });
                selectedProduct.setProductCardState({ type: "ReduceQty", payload: CartProductDetails.CalculatedUOMQuantity })
              }
              else if (UpdateCartProductQtyResponse.Status === "Error") {
                showToast("Something Went Wrong.Please Contact Admin", "error", 3000);
              }
            }
          }
          else if (SameProductResponse.Status === "Error") {
            showToast("Something Went Wrong.Please Contact Admin", "error", 3000);
          }
        }

        else if (CartProductRelatedStates.CartDetails.Status === "InProgress") {
          const CartStatusCheckingResponse = await CartStatusChecking({ CartAutoid: CartProductRelatedStates.CartDetails.Data.id })

          if (CartStatusCheckingResponse.Status === "Success") {
            if (CartStatusCheckingResponse.Data.CartStatus === "Open") {
              showToast(`Ordered request Failed. Contact admin.`, "error");
              CartRelatedDispatch({ type: Actions.CartDetailsLoaded, payload: CartStatusCheckingResponse.Data })
            }
            else if (CartStatusCheckingResponse.Data.CartStatus === "InProgress") {
              showToast(`Your previous order request is currently being processed. Please try again after the order request has been processed.`);
            }
            else if (CartStatusCheckingResponse.Data.CartStatus === "Ordered") {
              showToast(`Your previous order request submitted  with Order ID: ${CartStatusCheckingResponse.Data.SalesOrderId}.`, "success")
              showToast("Add the Product again to the cart", "info", 3000);
              CartRelatedDispatch({ type: Actions.CartDetailsLoaded, payload: { Status: "NoCart", Data: [] } });
              CartRelatedDispatch({ type: Actions.CartProductsLoaded, payload: { Status: "EmptyCart",Data: [], CartProductsIDs: [] } });
            }

          }
          else if (CartStatusCheckingResponse.Status === "Error") {
            showToast("Something Went Wrong.Please Contact Admin", "error", 3000);
          }
        }
      }
      else {
        showToast(`${t('Please wait a moment before clicking again. Thank you for your patience!')} `, "info", 2000)
      }

    } catch (error) {
      console.log("Add to Cart Error", error)
    }
    finally {
      setLoading(false);
      setDialogVisible(false);
      setCount(1);
    }


  }
  return (
    <div className='flex justify-content-between align-items-center  mt-4'>

      <div >
        <input type="text"
          value={count === "" ? "" : count}
          className=" bg-gray-50 hover:bg-gray-100 focus:bg-gray-100 w-50 "
          style={{
            fontSize: "14px", padding: "0px", height: '35px',
            textAlign: "center", outline: "none", borderRadius: '5px'
          }}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
        />

        {selectedProduct.ChangeUOMDetails && <span
          className="mt-2 pr-2 pl-2 capitalize"
          style={{ fontSize: "12px" }}
        > <UOMConversion UOMCode={selectedProduct.ChangeUOMDetails.UOM} /> </span>}
        {!selectedProduct.ChangeUOMDetails && <span
          className="mt-2 pr-2 pl-2 capitalize"
          style={{ fontSize: "12px" }}
        > <UOMConversion UOMCode={selectedProduct.Product.ProductUOM} /></span>}

      </div>

      <Button loading={loading} label={loading ? `Adding ` : `Add to Cart`} onClick={handleAddToCart} icon={<AddShoppingCart ></AddShoppingCart>}
        iconPos="left" raised className="primary-button  font-semibold  border-none  text-sm" />
    </div>
  )
}

export default InputAndAddtoCartUI